/** Posted live hours. Change LIVE_TZ if your evenings are elsewhere. */
export const LIVE_TZ = 'Asia/Kolkata';
export const LIVE_DAYS = [4, 5, 6, 0];
export const LIVE_START_HOUR = 20;
export const LIVE_END_HOUR = 23;
export const SEO_LINE = 'Live windows: Thursday–Sunday, 8–11pm India time (IST).';

const DOW = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

export function getTzParts(date, timeZone = LIVE_TZ) {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone,
    weekday: 'short',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(date);
  const map = Object.fromEntries(parts.filter((part) => part.type !== 'literal').map((part) => [part.type, part.value]));
  let hour = Number(map.hour);
  if (hour === 24) hour = 0;
  return {
    weekday: DOW[map.weekday] ?? 0,
    year: Number(map.year),
    month: Number(map.month),
    day: Number(map.day),
    hour,
    minute: Number(map.minute),
  };
}

export function zonedDate(year, month, day, hour, minute, timeZone = LIVE_TZ) {
  const guess = new Date(Date.UTC(year, month - 1, day, hour, minute, 0));
  const got = getTzParts(guess, timeZone);
  const gotUtc = Date.UTC(got.year, got.month - 1, got.day, got.hour, got.minute, 0);
  const wantUtc = Date.UTC(year, month - 1, day, hour, minute, 0);
  return new Date(guess.getTime() + (wantUtc - gotUtc));
}

function addCalendarDays(year, month, day, extra) {
  const utc = new Date(Date.UTC(year, month - 1, day + extra));
  return {
    year: utc.getUTCFullYear(),
    month: utc.getUTCMonth() + 1,
    day: utc.getUTCDate(),
  };
}

function formatClock(date) {
  return new Intl.DateTimeFormat(undefined, { hour: 'numeric', minute: '2-digit' }).format(date);
}

function formatLiveNow(endsAt) {
  return `Live now until ${formatClock(endsAt)} your time. Stay, or invite someone in.`;
}

function formatNext(startsAt, endsAt) {
  const day = new Intl.DateTimeFormat(undefined, { weekday: 'long' }).format(startsAt);
  return `Next live window: ${day} ${formatClock(startsAt)}–${formatClock(endsAt)} your time. Come back then, or invite a friend.`;
}

export function getLiveStatus(now = new Date(), timeZone = LIVE_TZ) {
  const here = getTzParts(now, timeZone);
  const minutes = here.hour * 60 + here.minute;
  const startM = LIVE_START_HOUR * 60;
  const endM = LIVE_END_HOUR * 60;

  if (LIVE_DAYS.includes(here.weekday) && minutes >= startM && minutes < endM) {
    const startsAt = zonedDate(here.year, here.month, here.day, LIVE_START_HOUR, 0, timeZone);
    const endsAt = zonedDate(here.year, here.month, here.day, LIVE_END_HOUR, 0, timeZone);
    return { live: true, startsAt, endsAt, line: formatLiveNow(endsAt), seoLine: SEO_LINE };
  }

  for (let offset = 0; offset <= 8; offset += 1) {
    const calendar = addCalendarDays(here.year, here.month, here.day, offset);
    const noon = zonedDate(calendar.year, calendar.month, calendar.day, 12, 0, timeZone);
    const parts = getTzParts(noon, timeZone);
    if (!LIVE_DAYS.includes(parts.weekday)) continue;
    if (offset === 0 && minutes >= endM) continue;

    const startsAt = zonedDate(parts.year, parts.month, parts.day, LIVE_START_HOUR, 0, timeZone);
    const endsAt = zonedDate(parts.year, parts.month, parts.day, LIVE_END_HOUR, 0, timeZone);
    return { live: false, startsAt, endsAt, line: formatNext(startsAt, endsAt), seoLine: SEO_LINE };
  }

  return { live: false, startsAt: null, endsAt: null, line: SEO_LINE, seoLine: SEO_LINE };
}
